<template>
	<div class="data-board-container">
		<div class="dataBox">
			<div class="dataItem">
				<img class="dataIcon" src="../../assets/Painter/dataA.png" />
				<div class="data">
					<div class="title">
						作品总数
					</div>
					{{userInfo.zp_count ? userInfo.zp_count : 0}}
				</div>
			</div>
			<div class="dataItem">
				<div class="line"></div>
				<img class="dataIcon" src="../../assets/Painter/dataB.png" />
				<div class="data">
					<div class="title">
						粉丝总数
					</div>
					{{userInfo.fans_count ? userInfo.fans_count : 0}}
				</div>
			</div>
			<div class="dataItem">
				<div class="line"></div>
				<img class="dataIcon" src="../../assets/Painter/dataC.png" />
				<div class="data">
					<div class="title">
						作品订单总收入
					</div>
					{{userInfo.order_price ? (userInfo.order_price * 1).toFixed(2) : 0}}
				</div>
			</div>
			<div class="dataItem">
				<div class="line"></div>
				<img class="dataIcon" src="../../assets/Painter/dataD.png" />
				<div class="data">
					<div class="title">
						定制订单总收入
					</div>
					{{userInfo.dz_price ? (userInfo.dz_price * 1).toFixed(2) : 0}}
				</div>
			</div>
		</div>
		<div class="dataBox" style="margin-top: .24rem;">
			<div class="dataItem">
				<img class="dataIcon" src="../../assets/Painter/dataE.png" />
				<div class="data">
					<div class="title">
						今日新增作品数
					</div>
					{{userInfo.zp_count_today ? userInfo.zp_count_today : 0}}
				</div>
			</div>
			<div class="dataItem">
				<div class="line"></div>
				<img class="dataIcon" src="../../assets/Painter/dataF.png" />
				<div class="data">
					<div class="title">
						今日新增粉丝数
					</div>
					{{userInfo.fans_count_today ? userInfo.fans_count_today : 0}}
				</div>
			</div>
			<div class="dataItem">
				<div class="line"></div>
				<img class="dataIcon" src="../../assets/Painter/dataG.png" />
				<div class="data">
					<div class="title">
						今日新增作品订单收入
					</div>
					{{userInfo.order_price_today ? (userInfo.order_price_today * 1).toFixed(2) : 0}}
				</div>
			</div>
			<div class="dataItem">
				<div class="line"></div>
				<img class="dataIcon" src="../../assets/Painter/dataH.png" />
				<div class="data">
					<div class="title">
						今日新增定制订单收入
					</div>
					{{userInfo.dz_price_today ? (userInfo.dz_price_today * 1).toFixed(2) : 0}}
				</div>
			</div>
		</div>
		<div class="echarts">
			<div class="title">用户主页访问量走势图</div>
			<div id="myChart" style="width: 100%;height: 5.24rem;"></div>
		</div>
	</div>
</template>

<script>
	//引入基本模板
	let echarts = require("echarts/lib/echarts");
	// 引入折线图等组件
	require("echarts/lib/chart/line");
	// 引入提示框和title组件，图例
	require("echarts/lib/component/tooltip");
	require("echarts/lib/component/grid");
	require("echarts/lib/component/legend");

	export default {
		name: "DataBoard",
		data() {
			return {
				userInfo: {},
				// 注意：数据必须有初始值，否则tooltip不会显示
				// 注意：数据现在是写死的，可以请求接口之后重新赋值，生成动态折线图
				xArray_temper: [
					"2019-02-25",
					"2019-03-04",
					"2019-03-18",
					"2019-03-26",
					"2019-04-16",
					"2019-04-26",
					"2019-05-04"
				],
				yArray_temper: [200, 20, 100, 50, 30, 20, 10]
			};
		},
		created() {
			// var _this = this;
			// setTimeout(function() {
			// 	// 这里没有动态数据，所以用计时器进行了模拟
			// 	// 实际情况应该在获取数据之后调用，且必须保证图表元素已经挂载到页面中去了
			// 	_this.drawLine();
			// }, 500);
			this.userDetails()
		},
		methods: {
			userDetails() {
				this.$api.post('/UserD/user_details', {}).then(res => {
					if (res.code == 1) {
						this.userInfo = res.data
						this.xArray_temper = this.userInfo.week_data.map(item => item.time)
						this.yArray_temper = this.userInfo.week_data.map(item => item.count)
						this.drawLine();
					} else {
						console.log(res.msg)
					}
				}).catch(err => {
					console.log(err);
				})
			},
			drawLine() {
				let that = this
				// 基于准备好的dom，初始化echarts实例
				let myChart = echarts.init(document.getElementById("myChart"));

				// 屏幕尺寸变化时，重新调整图表元素大小
				let sizeFun = function() {
					myChart.resize();
				};
				window.addEventListener("resize", sizeFun);

				// 绘制图表
				myChart.setOption({
					grid: {
						left: '2%',
						right: '2%',
						top: '20%',
						bottom: '6%',
						containLabel: true
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'line',
							lineStyle: {
								color: 'rgba(228, 157, 102, 1)'
							},
						}
					},
					xAxis: [{
						type: 'category',
						boundaryGap: 1,
						axisLine: {
							show: true,
						},
						axisLabel: {
							color: '#909399'
						},
						splitLine: {
							show: false
						},
						axisTick: {
							show: false
						},

						data: that.xArray_temper
					}],
					yAxis: [{
							type: 'value',
							name: '',
							padding: 5,
							// max: 1000,
							splitLine: {
								show: true,
								lineStyle: {
									color: '#DCDFE6',
									type: 'dashed'
								}
							},
							axisLine: {
								show: false
							},
							axisLabel: {
								show: true,
								margin: 10,
								textStyle: {
									color: '#909399'

								}
							},
							axisTick: {
								show: false
							}
						},

					],
					series: [{
							name: '访问人数',
							type: 'line',
							smooth: true,
							stack: '总量',
							symbolSize: 5,
							itemStyle: {
								normal: {
									color: '#E49D66',
									lineStyle: {
										color: "#E49D66",
										width: 2
									},
								}
							},
							areaStyle: {
								normal: {
									color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
											offset: 0,
											color: 'rgba(228, 157, 102, 1)'
										},
										{
											offset: 1,
											color: 'rgba(255, 255, 255, 0.2)'
										}
									], false),
								}
							},
							data: that.yArray_temper
						},

					]
				});
			}
		},
	};
</script>

<style lang="scss" scoped>
	.data-board-container {
		display: flex;
		flex-direction: column;
		padding: .32rem .24rem;
	}

	.dataBox {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 0 .32rem;
		height: 1.3rem;
		background: #FFFFFF;
		box-shadow: 5px 6px 15px 0px rgba(159, 159, 159, 0.05);
		border-radius: .08rem;

		.line {
			margin-right: .32rem;
			width: .01rem;
			height: .6rem;
			background: #DCDFE6;
		}

		.dataItem {
			width: 25%;
			display: flex;
			align-items: center;

			.dataIcon {
				width: .66rem;
				height: .66rem;
			}

			.data {
				margin-left: .16rem;
				display: flex;
				flex-direction: column;
				font-weight: bold;
				font-size: .24rem;
				color: #252525;

				.title {
					font-weight: 400;
					font-size: .14rem;
					color: #999999;
				}
			}
		}
	}

	.echarts {
		margin-top: .24rem;
		width: 100%;
		height: 5.24rem;
		background: #FFFFFF;
		box-shadow: 5px 6px 15px 0px rgba(159, 159, 159, 0.05);
		border-radius: .08rem;
		position: relative;

		.title {
			position: absolute;
			top: .32rem;
			left: .32rem;
			font-weight: 500;
			font-size: .18rem;
			color: #3A3A38;
			line-height: 26px;
		}
	}
</style>